import { AttributesUtil } from '../attributes/attributes.util';
import { ErrorCdsEnums } from 'src/app/shared/errorcds.enums';
import { CommonEnums } from 'src/app/shared/common.enums';
import { OutputWrapper } from 'src/app/modules/design/transforms/output/output.wrapper';
import { Attribute } from '../../models/domain/attribute';
import { AttributesGridUtil } from '../attributes/attributes-grid.util';
import { OutputWrapper1 } from 'src/app/modules/design/transforms/output1/output1.wrapper';

export class Output_Attr_LnkTabulator {
    private static instance: Output_Attr_LnkTabulator;

    static getInstance() {
        if (!Output_Attr_LnkTabulator.instance) {
            Output_Attr_LnkTabulator.instance = new Output_Attr_LnkTabulator();
        }

        return Output_Attr_LnkTabulator.instance;
    }

    /**
    * Output_Attr_LnkColumns is a singleton class, so use Output_Attr_LnkColumns.getInstance() method instead of creating new Output_Attr_LnkColumns().
    */
    private constructor() {
    }

    getCheckBoxColumn(outPutWrapper: OutputWrapper): any {
        let column: any = {};

        if (outPutWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.formatter = "rowSelection"
        column.width = 40;
        column.align = "center";
        column.titleFormatter = "rowSelection"
        column.resizableColumn = false;
        column.headerSort = false
        return column;
    }

    getAttr_Id(): any {
        let column: any = {};

        column.title = "Id";
        column.field = "attr_Id";
        column.width = 100;
        column.headerSort = false;
        column.visible = false;

        return column;
    }

    getSrt_Order(): any {
        let column: any = {};

        column.title = "#";
        column.field = 'srt_Order';
        column.width = 50;
        column.headerSort = false;

        column.formatter = function (cell) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.isEditable == CommonEnums.flag.YES)
                return attribute.srt_Order + 1;

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.srt_Order + 1;

            return element;
        }
        return column;
    }

    getAttrNm(outPutWrapper: OutputWrapper): any {
        let column: any = {};

        column.title = "Attribute Name";
        column.field = 'attrNm';
        column.width = 200;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getData();

            return attribute.attrNm;
        }

        return column;
    }

    getAttrDTyp_Id(outPutWrapper: OutputWrapper): any {
        let column: any = {};

        column.title = "Data Type";
        column.field = 'attrDTyp_Id';
        column.width = 150;
        column.headerSort = false;

        column.formatter = function (cell) {
            let attribute: Attribute = cell.getData();

            return attribute.attrDTypNm;
        }

        return column;
    }

    getOutPutLnk_Attr_Id(outPutWrapper: OutputWrapper): any {
        let column: any = {};

        column.title = "Input Attribute";
        column.field = 'lnk_Attr_Id';
        column.width = 250;
        column.headerSort = false;

        column.formatter = function getValue(cell) {
            let attribute: Attribute = cell.getData();
            if (attribute.lnk_Obj_Id == -1 &&
                attribute.lnk_Attr_Id == -1) {
                return '';
            }

            let attributeObj: any = outPutWrapper.carryForwardAttributesHMapIds.get(attribute.lnk_Obj_Id + '-' + attribute.lnk_Attr_Id);
            if (!attributeObj) return "";

            return attributeObj.name;
        }

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getData();

            let editor: any;
            editor = document.createElement("select");
            editor.id = "mySelect";
            if (outPutWrapper.mode_Ind == 'R') return;
            if (outPutWrapper.carryForwardGroupAttributes.length > 0) {
                let obj_Nm: string = '';
                for (let i: number = 0; i < outPutWrapper.carryForwardGroupAttributes.length; i++) {
                    let option: any = document.createElement("option");

                    if (obj_Nm != outPutWrapper.carryForwardGroupAttributes[i].obj_Nm) {
                        obj_Nm = outPutWrapper.carryForwardGroupAttributes[i].obj_Nm;

                        option.value = outPutWrapper.carryForwardGroupAttributes[i].obj_Nm;
                        option.text = outPutWrapper.carryForwardGroupAttributes[i].obj_Nm;
                        editor.appendChild(option);
                    }

                    option.value = outPutWrapper.carryForwardGroupAttributes[i].obj_Id + '-' + outPutWrapper.carryForwardGroupAttributes[i].attr_Id;
                    option.text = outPutWrapper.carryForwardGroupAttributes[i].name;

                    editor.appendChild(option);
                }
            }

            editor.value = attribute.lnk_Obj_Id + "-" + attribute.lnk_Attr_Id;
            //cell.getValue();

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                if (editor.value == "") {
                    success(editor.value);
                    return;
                }

                // if (editor.value == oldValue) {
                //     success(editor.value);
                //     return;
                // }

                let obj_Attr_Ids: Array<any> = editor.value.split('-');

                attribute.lnk_Obj_Id = parseInt(obj_Attr_Ids[0]);
                attribute.lnk_Attr_Id = parseInt(obj_Attr_Ids[1]);

                for (let i: number = 0; i < outPutWrapper.carryForwardGroupAttributes.length; i++) {
                    let carryForwardGroupAttribute: any = outPutWrapper.carryForwardGroupAttributes[i];

                    if (carryForwardGroupAttribute.obj_Id == attribute.lnk_Obj_Id &&
                        carryForwardGroupAttribute.attr_Id == attribute.lnk_Attr_Id) {

                        attribute.valid_Cd = AttributesGridUtil.getInstance().verifyFamily(attribute, carryForwardGroupAttribute, outPutWrapper) ? "0" : "-1";
                        break;
                    }
                }
                outPutWrapper.doValidate();
                success(attribute.lnk_Attr_Id);

                setTimeout(() => {
                    cell.getRow().reformat();
                });

            }

            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }
        return column;
    }

    // "<div ng-if='::dataItem.isEditable == \"N\" '><span class='italic'>
    // {{objectWrapper.carryForwardAttributesHMapIds[dataItem.lnk_Obj_Id + '-' + dataItem.lnk_Attr_Id].name}}
    // </span></div>" +  
    // "<div ng-if='::dataItem.isEditable != \"N\" '><select class='select-style form-control' 
    // ng-model='attributeGridData.selectedCarryForwardAttributeObject'  
    // ng-value='attributeGridData.selectedCarryForwardAttributeObject'"
    // + " ng-change='lnk_Attr_IdChanged(attributeGridData.selectedCarryForwardAttributeObject,
    // dataItem, objectWrapper)' " 
    // + " ng-options='carryForwardGroupAttribute.name group by carryForwardGroupAttribute.obj_Nm 
    // for carryForwardGroupAttribute "
    // + " in objectWrapper.carryForwardGroupAttributes'></select></div>"

    getOutPutLnk_Attr_Datatype(outPutWrapper: OutputWrapper): any {
        let column: any = {};

        column.title = "Input Data Type";
        column.field = "";
        column.width = 150;
        column.headerSort = false;

        column.formatter = function getValue(cell) {
            let attribute: Attribute = cell.getData();
            if (attribute.lnk_Obj_Id == -1 &&
                attribute.lnk_Attr_Id == -1) {
                return '';
            }

            let attributeObj: any = outPutWrapper.carryForwardAttributesHMapIds.get(attribute.lnk_Obj_Id + '-' + attribute.lnk_Attr_Id);
            if (!attributeObj) return "";

            return attributeObj.attrDTypNm;
        }

        column.editor = function (cell) {
            let attribute: Attribute = cell.getData();

            let attributeObj: any = outPutWrapper.carryForwardAttributesHMapIds.get(attribute.lnk_Obj_Id + '-' + attribute.lnk_Attr_Id);
            if (!attributeObj) return "";

            return attributeObj.attrDTypNm;
        }
        return column;
    }

    getValid_Cd(outPutWrapper: OutputWrapper): any {
        let column: any = {};

        column.title = "!";
        column.field = 'valid_Cd';
        column.width = 20;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            if (cell.getValue() == "0") {
                return '';
            }
            return "<i " + ErrorCdsEnums.errorcds[cell.getValue()] + "' class='text-warning fs-9 fa fa-circle hand'></i>";
        }
        return column;
    }

    getAttrPrec(outputWrapper: OutputWrapper): any {
        let column: any = {};

        column.title = "Prec";
        column.field = 'attrPrec';
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (!attribute.showAttrPrec) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.attrPrec
            }
            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.attrPrec;

            return element;
        }

        if (outputWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (outputWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (!attribute.showAttrPrec) {
                let element: any = document.createElement("span");
                return element;
            }

            if (attribute.isEditable == CommonEnums.flag.NO) {
                let element: any = document.createElement("span");
                element.classList.add("font-italic");
                element.style.paddingLeft = (attribute.clevel * 5) + 'px';
                element.innerHTML = attribute.attrPrec;
                return element;
            }

            let editor: any = document.createElement("input");
            editor.type = "number";
            editor.id = "myInput";
            editor.min = attribute.minAttrPrec;
            editor.max = attribute.maxAttrPrec;

            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            let oldAttrPrec: number = attribute.attrPrec;

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.attrPrec = editor.value;

                if (editor.value != oldAttrPrec) {
                    if (editor.value < attribute.minAttrPrec ||
                        editor.value > attribute.maxAttrPrec) {
                        attribute.attrPrec = oldAttrPrec;
                        editor.value = oldAttrPrec;
                    } else {
                        outputWrapper.setChange_Ind();
                    }
                }
            }
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }

    getAttrScale(outputWrapper: OutputWrapper): any {
        let column: any = {};

        column.title = "Scale";
        column.field = 'attrScale';
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (!attribute.showAttrScale) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.attrScale;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.attrScale;

            return element;
        }

        if (outputWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (outputWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (!attribute.showAttrScale) {
                let element: any = document.createElement("span");
                return element;
            }

            if (attribute.isEditable == CommonEnums.flag.NO) {
                let element: any = document.createElement("span");
                element.classList.add("font-italic");
                element.innerHTML = attribute.attrScale;
                return element;
            }

            let editor: any = document.createElement("input");
            editor.type = 'number';
            editor.id = "myInput";

            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            let oldAttrScale: number = attribute.attrScale;

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.attrScale = editor.value;

                if (editor.value != oldAttrScale) {
                    if (editor.value < attribute.minAttrScale ||
                        editor.value > attribute.maxAttrScale) {
                        attribute.attrPrec = oldAttrScale;
                        editor.value = oldAttrScale;
                    } else {
                        outputWrapper.setChange_Ind();
                    }
                }
            }
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }

}